// extracted by mini-css-extract-plugin
export var standaloneTable = "_1j-0";
export var standaloneTableWithBodyFill = "_1j-1";
export var withExtraHeader = "_1j-2";